export const REQUEST_POPULAR_HOTELS = 'popularHotels/REQUEST_POPULAR_HOTELS';
export const SET_POPULAR_HOTELS = 'popularHotels/SET_POPULAR_HOTELS';
